//
//
//
//
//
//
//
//
//
//

const cmsPageKey = {
  "blog-slug": "#!/template/cmsadmin~2Fdefault~2Findex/update/"
};
const availablePageKey = [
  'blog-slug'
];

export default {
  computed: {
    isVisible: function () {
      const userDynamicFields = this.$store.state?.user?.user?.dynamicFields;
      if (!userDynamicFields) {
        return false
      }

      const adminLink = userDynamicFields?.a_link;
      const isAdmin = Boolean(String(userDynamicFields?.is_a) === 'true');
      if (!isAdmin || !adminLink) {
        return false
      }

      const routeName = this.$route?.name || "";
      const isFindPage = Boolean(availablePageKey.find((key) => Boolean(String(routeName || '').includes(key))));
      if (!isFindPage) {
        return false
      }

      return true
    }
  },

  methods: {
    createElementA: async function (link) {
      const adminLink = this.$store.state?.user?.user?.dynamicFields?.a_link;
      const elementA = document.createElement("a");
      const elementId = [
        (Math.random() + 1).toString(36).substring(7),
        (Math.random() + 1).toString(36).substring(7),
        (Math.random() + 1).toString(36).substring(7)
      ].join("_");
      elementA.id = elementId;
      elementA.href = [adminLink, link].join('');
      elementA.target = "_blank";
      document.body.appendChild(elementA);
      document.getElementById(elementId).click();
    },

    clickButton: async function () {
      const routeName = this.$route?.name || "";
      if (routeName.includes("blog-slug")) {
        const slug = this.$route?.params?.slug;
        const cmsPageId = await this.$api.agent.transport.get(`/articles/${ slug }`).then((res) => res?.data?.cms_page_id || null).catch((err) => null);
        if (!cmsPageId) {
          this.$toast.error("Страница не найдена")
          return
        }
        const navPageId = await this.$api.agent.transport.get(`/cms/page/${ cmsPageId }`).then((res) => res?.data?.page?.nav_id || null).catch((err) => null);
        if (!navPageId) {
          this.$toast.error("Страница не найдена")
          return
        }

        await this.createElementA([cmsPageKey['blog-slug'], navPageId].join(''));
      }
    }
  }
}
